"use client";

import { useGlobalSlotContext } from "@/context/GlobalSlotContext";
import useIdleReady from "@/hooks/useIdleReady";
import { MonarchSlot } from "@redventures/cohesion-utils-react";
import type { ReactNode } from "react";

type DynamicMonarchSlotProps = {
  slotId: string;
  children?: ReactNode;
  fallback?: ReactNode;
  deferUntilIdle?: boolean;
};

function DynamicMonarchSlotInner({
  slotId,
  children,
  fallback,
}: Omit<DynamicMonarchSlotProps, "deferUntilIdle">) {
  const globalSlotContext = useGlobalSlotContext();
  const generatedSlotId = globalSlotContext?.getSlotId(slotId) ?? slotId;

  return (
    <>
      <MonarchSlot slotId={generatedSlotId} fallback={fallback}>
        {children}
      </MonarchSlot>
    </>
  );
}

export default function DynamicMonarchSlot({
  slotId,
  children,
  fallback,
  deferUntilIdle = false,
}: DynamicMonarchSlotProps) {
  const hasReachedIdle = useIdleReady({
    enabled: deferUntilIdle,
  });
  const shouldRenderSlot = !deferUntilIdle || hasReachedIdle;

  if (!shouldRenderSlot) {
    return <>{fallback}</>;
  }

  return (
    <DynamicMonarchSlotInner slotId={slotId} fallback={fallback}>
      {children}
    </DynamicMonarchSlotInner>
  );
}
